export default __webpack_public_path__ + "static/media/tree_View.7e6dafe1.svg";